// product details read more
document.addEventListener('DOMContentLoaded', function() {
  const buttons = document.querySelectorAll('.product-details-description .read-more-btn');

  buttons.forEach(function(btn) {
    const desc = btn.previousElementSibling; // .description-text

    if (desc) {
      // 2-line check (like earlier logic)
      const lineHeight = parseInt(window.getComputedStyle(desc).lineHeight, 10);
      const maxHeight = lineHeight * 2;

      // Add collapsed style initially
      if (desc.scrollHeight > maxHeight) {
        desc.style.maxHeight = maxHeight + 'px';
        desc.style.overflow = 'hidden';
      } else {
        btn.style.display = 'none'; // not truncated → hide button
      }

      // Toggle expand/collapse
      btn.addEventListener('click', function() {
        const expanded = desc.classList.toggle('expanded');

        if (expanded) {
          desc.style.maxHeight = 'none';
          btn.innerHTML = 'Leer menos <span class="toggle-icon">−</span>';
          btn.setAttribute("aria-expanded", "true");
        } else {
          desc.style.maxHeight = maxHeight + 'px';
          btn.innerHTML = 'Leer más <span class="toggle-icon">+</span>';
          btn.setAttribute("aria-expanded", "false");
        }
      });
    }
  });
});
